import {useEffect, useRef, useState} from "react";

interface IUseAccumulatedResultsOptions<T> {
    results?: T[];
    isLoading: boolean;
    accumulationTime?: number;
}

interface IUseAccumulatedResultsReturn<T> {
    accumulatedResults: T[];
    hasBeenAccumulated: boolean;
}

const DEFAULT_ACCUMULATION_TIME = 5000;

export function useAccumulatedResults<T>({
    results,
    isLoading,
    accumulationTime = DEFAULT_ACCUMULATION_TIME
}: IUseAccumulatedResultsOptions<T>): IUseAccumulatedResultsReturn<T> {
    const [accumulatedResults, setAccumulatedResults] = useState<T[]>([]);
    const [hasInitialLoad, setHasInitialLoad] = useState(false);
    const [hasBeenAccumulated, setHasBeenAccumulated] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const lastResultsRef = useRef<T[]>([]);

    useEffect(() => {
        if (hasBeenAccumulated) {
            return;
        }

        if (!isLoading && results?.length && results !== lastResultsRef.current) {
            setAccumulatedResults((prev) => {
                return [...prev, ...results];
            });

            setHasInitialLoad(true);
            lastResultsRef.current = results;
        }
    }, [isLoading, results, hasBeenAccumulated]);

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (!hasBeenAccumulated && hasInitialLoad && accumulatedResults.length > 0) {
            // Wait a bit to ensure no more data is coming
            timeoutRef.current = setTimeout(() => {
                setHasBeenAccumulated(true);
            }, accumulationTime);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [hasInitialLoad, accumulatedResults, accumulationTime, hasBeenAccumulated]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return {
        accumulatedResults,
        hasBeenAccumulated
    };
}
import {useEffect, useRef, useState} from "react";

interface IUseAccumulatedResultsOptions<T> {
    results?: T[];
    isLoading: boolean;
    accumulationTime?: number;
}

interface IUseAccumulatedResultsReturn<T> {
    accumulatedResults: T[];
    hasBeenAccumulated: boolean;
}

const DEFAULT_ACCUMULATION_TIME = 5000;

export function useAccumulatedResults<T>({
    results,
    isLoading,
    accumulationTime = DEFAULT_ACCUMULATION_TIME
}: IUseAccumulatedResultsOptions<T>): IUseAccumulatedResultsReturn<T> {
    const [accumulatedResults, setAccumulatedResults] = useState<T[]>([]);
    const [hasInitialLoad, setHasInitialLoad] = useState(false);
    const [hasBeenAccumulated, setHasBeenAccumulated] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const lastResultsRef = useRef<T[]>([]);

    useEffect(() => {
        if (hasBeenAccumulated) {
            return;
        }

        if (!isLoading && results?.length && results !== lastResultsRef.current) {
            setAccumulatedResults((prev) => {
                return [...prev, ...results];
            });

            setHasInitialLoad(true);
            lastResultsRef.current = results;
        }
    }, [isLoading, results, hasBeenAccumulated]);

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (!hasBeenAccumulated && hasInitialLoad && accumulatedResults.length > 0) {
            // Wait a bit to ensure no more data is coming
            timeoutRef.current = setTimeout(() => {
                setHasBeenAccumulated(true);
            }, accumulationTime);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [hasInitialLoad, accumulatedResults, accumulationTime, hasBeenAccumulated]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return {
        accumulatedResults,
        hasBeenAccumulated
    };
}
